/**
 * Channels service
 */

import Resource from './resource'

export default new Resource('channels')



// WEBPACK FOOTER //
// ./src/libraries/services/channels.js